export const MonthNames = [
  'Januari',
  'Februari',
  'Mars',
  'April',
  'Maj',
  'Juni',
  'Juli',
  'Augusti',
  'September',
  'Oktober',
  'November',
  'December',
];

export const toInterval = <T extends IDateInterval>({ from, to, ...rest }: T) => ({
  ...rest,
  start: new Date(from),
  end: new Date(to),
});

export const setTimeToMidnight = (date: Date) => {
  const newDate = new Date(date);

  newDate.setHours(0);
  newDate.setMinutes(0);
  newDate.setMinutes(0);
  newDate.setSeconds(0);
  newDate.setMilliseconds(0);

  return newDate;
};
